/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterGSmall = createReactComponent("outline", "letter-g-small", "IconLetterGSmall", [["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }]]);

export { IconLetterGSmall as default };
//# sourceMappingURL=IconLetterGSmall.mjs.map
